import ModalDeleteFilled from '../../../../../../baseComponents/ModalsLayouts/ModalDeleteFilled'
import { ModalEditComponentProps } from '../../../../../../baseComponents/ModalsLayouts/types'
import { useFetchText } from '../../../../../../utils/hooks/useFetchText'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'


interface ModalDeleteLabelProps extends ModalEditComponentProps { }

const ModalDeleteLabel: React.FC<ModalDeleteLabelProps> = ({ setOpened, onSubmit, allRowData }) => {
    const { t } = useTwinTranslation()
    const { handleFetchText } = useFetchText({
        onSubmit,
        url: '/api/app/config/label/deleteLabel',
        data: {
            id: allRowData?.id,
        }
    })
    let translations = {
        title: t('sureDeleteLabel', '¿Seguro quieres eliminar esta etiqueta?'),
        subtitle: t('onceDeletedNotRecoverM', 'Una vez eliminado no podrás recuperarlo'),
    }
    return (
        <ModalDeleteFilled opened={true} setOpened={setOpened} onCancel={() => setOpened(null)} onAccept={handleFetchText} translations={translations} />
    )
}

export default ModalDeleteLabel